import { AjaxResponseUpdater } from '../../angular15/upgrader/audit/ajax-response-updater';
import { CssSyntaxErrorUpdater } from '../../angular15/upgrader/audit/css-syntax-error-updater';
import { ParameterCountViolationUpdater } from '../../angular15/upgrader/audit/parameter-count-violation-updater';
import { DeclareOverrideUpdater } from '../../angular15/upgrader/audit/declare-override-updater';
import { LoadChildrenCallbackUpdater } from '../../angular15/upgrader/audit/load-children-callback-updater';
import { FormControlUpdater } from '../../angular15/upgrader/audit/form-control-updater';
import { ObservableThrowUpdater } from '../../angular15/upgrader/audit/observable-throw-updater';
import { StringReplaceUpdater } from '../../angular15/upgrader/audit/string-replace-updater';
import { ComponentSelectorUpdater } from './component-selector-updater';
import { OnlyArrowFunctionsUpdater } from './only-arrow-functions-updater';

export class UpdaterLookup {
    private static functionLookup: any;

    public static initialize(angularVersion?: string) {
        switch(angularVersion) {
            case '15':
                if (!UpdaterLookup.functionLookup) {
                    UpdaterLookup.functionLookup = {
                        // Errors
                        'TS2612': new DeclareOverrideUpdater(),
                        'TS2322': new LoadChildrenCallbackUpdater(),
                        'TS2339': new ObservableThrowUpdater(),
                        'TS2554': new ParameterCountViolationUpdater(),
                        'TS2314': new AjaxResponseUpdater(),
                        'TS2542': new StringReplaceUpdater(),
                        'TS2345': new FormControlUpdater(),
                        // Warnings
                        'css-syntax-error': new CssSyntaxErrorUpdater(),
                    };
                }
            case '11':
            default:
                if (!UpdaterLookup.functionLookup) {
                    UpdaterLookup.functionLookup = {
                        'only-arrow-functions': new OnlyArrowFunctionsUpdater(),
                        'component-selector': new ComponentSelectorUpdater()
                    };
                }
        }

        return UpdaterLookup.functionLookup;
    }
}
